import { Link } from "react-router-dom";
import type { Product } from "../products";

export default function ProductCard({ product }: { product: Product }) {
  return (
    <Link to={`/product/${product.slug}`} className="product-card">
      <div
        className="product-card__visual"
        style={{ background: product.gradient }}
      >
        {product.image ? (
          <img
            src={product.image}
            alt={`${product.proprietaryName} — ${product.pharmaceuticalName} (${product.strength})`}
            className="product-card__image"
            loading="lazy"
          />
        ) : (
          <div className="product-card__placeholder">
            <span className="product-card__mark">{product.proprietaryName.charAt(0)}</span>
          </div>
        )}
        <span className={`product-card__badge product-card__badge--${product.category.toLowerCase()}`}>
          {product.category}
        </span>
      </div>
      <div className="product-card__body">
        <div className="product-card__meta">
          <span className="product-card__strength">{product.strength}</span>
          <span className="product-card__dot">·</span>
          <span className="product-card__form">{product.form}</span>
        </div>
        <h3 className="product-card__name">{product.proprietaryName}</h3>
        <p className="product-card__pharma">{product.pharmaceuticalName}</p>
        <p className="product-card__tag">{product.tagline}</p>
        <div className="product-card__cta">
          <span>Explore</span>
          <span className="product-card__arrow">→</span>
        </div>
      </div>
    </Link>
  );
}
